import "./GestorContenidos.scss";

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { TranslationProps } from "./TranslationTypes";
import { defaultMenuProps } from "../../constants/constants";
import 'dayjs/locale/es' // import locale
import { getApiTranslations, putApiUpdateTranslation } from "../../services/apiTranslation";
import InputText from "../../components/InputText/InputText";
import Button from "../../components/Button/Button";

const GestorContenidos = (): React.ReactElement =>{  
  const navigate = useNavigate();
  const [menuProps, setMenuProps] = useState<MenuProps>(defaultMenuProps);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [translations, setTranslations] = useState<TranslationProps[]>([]);

  useEffect(() => {
    loadTranslations()
  }, []);
  
  const loadTranslations = async (): Promise<void> => {
    const result: object = getApiTranslations({})
    .then(async (response: any) => {
      setTranslations(response.translations)
      setLoaded(true)
    })
    .catch((error: any) => {
      console.log(error.message);
      setTranslations([])
      setLoaded(true)
    });
  }
  
  const updateTranslation = async (attributes: TranslationProps): Promise<void> => {
    try{
      setLoaded(false)
      const result: object = await putApiUpdateTranslation(attributes)
      loadTranslations()
      alert("Contenido actualizado correctamente")
      setLoaded(true)
    }catch(err){
      alert("Hubo un error: " + err);
      setLoaded(true)
    }
  }
  
  return(
    <React.Fragment>
      <div id="menu">
        <Menu items={ menuProps.items } />
      </div>

      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Gestor de contenidos</h1>
          <span></span>
        </header>

        { loaded && 
          <div className="row mb-5">
            { translations.map((translation =>{
              let currentTranslation: TranslationProps = translation;
              
              return <React.Fragment key={translation.key}>
                <div className="col-12">
                  <h5 className="mb-3">{translation.key}</h5>
                  {translation.key && translation.key == 'heroGraphic' ? 
                    <p>En este apartado se puede modificar el video/imagen de la Home. Podéis incluir una url a un fichero de tipo MP4, JPG o PNG y el sistema automáticamente 
                      lo cambiará en la parte habilitada en la Home. Se recomienda un <b>ancho mínimo de 1400px</b> para que la calidad de la imagen sea correcta, el alto se ajusta proporcionalmente.</p>
                  : null }
                </div>
                
                <div className="col-12">
                  <InputText
                    className="mb-3"
                    type="text"
                    label="Castellano 🇪🇸"
                    value={translation.es ? translation.es : ''}
                    placeholder=""
                    onChange={(event: any) => { currentTranslation.es = event.currentTarget.value }} />
                    
                  <InputText
                    type="text"
                    label="English 🇬🇧"
                    value={translation.en ? translation.en : ''}
                    placeholder=""
                    onChange={(event: any) => { currentTranslation.en = event.currentTarget.value }} />
                    
                  <Button className={'btn-orange m-auto mt-3'} value={'Guardar'} onClick={ () => { updateTranslation(currentTranslation) } } />
                </div>
                  
                <hr className="mt-4 mb-5" />
                  
              </React.Fragment>;
            })) } 
          </div>
        }
      </div>
    </React.Fragment>
  )
}

export default GestorContenidos;